import { Component, Inject } from '@angular/core';
import { DateUtil } from 'app/core/utils/DateUtil';
import { BzgModalRef, BZG_MODAL_DATA, BzgToastService, BzgToastType } from 'bz-genome-angular';
import { I18nService } from 'i18n/i18n.service';

@Component({
  selector: 'working-time-schema-modal',
  templateUrl: './working-time-schema-modal.component.html',
  styleUrls: ['./working-time-schema-modal.component.scss']
})
export class WorkingTimeSchemaModalComponent {
  public currentDateType: string;
  public isWorking: boolean = false;

  public onDate: Date = new Date();

  public startDate: Date = new Date();
  public finishDate: Date = new Date();

  public fromTime = new Date();
  public toTime = new Date();

  public fromTimeStr = '00:00';
  public toTimeStr = '23:59';

  public idEdit: number = 0;

  public arrayHoursWorking = [];

  dateMinModified = new Date((new Date()).setFullYear((new Date()).getFullYear() - 10));
  dateMaxModified = new Date((new Date()).setFullYear((new Date()).getFullYear() + 10));

  constructor(
    public modalComponentRef: BzgModalRef,  
    private _toastService: BzgToastService,
    private _i18nService: I18nService,
    @Inject(BZG_MODAL_DATA) public data: { title: string, button?: string, workingTimeSchema?, isWorking?: boolean }) {
    if (this.data.workingTimeSchema) {
      if (this.data.workingTimeSchema.days === 1) {
        this.currentDateType = 'exact';
        this.onDate = new Date(this.data.workingTimeSchema.fromDate);
        this.startDate = new Date(this.data.workingTimeSchema.fromDate);
        this.finishDate = new Date(this.data.workingTimeSchema.fromDate);
      } else {
        this.currentDateType = 'range';
        this.startDate = new Date(this.data.workingTimeSchema.fromDate);
        this.finishDate = new Date(this.data.workingTimeSchema.toDate);
        this.onDate = new Date(this.data.workingTimeSchema.fromDate);
      }
      if (this.data.isWorking && this.data.workingTimeSchema) {
        for (let i = 1; i <= 5; i++) {
          if (!!this.data.workingTimeSchema[`fromTime${i}`] && !!this.data.workingTimeSchema[`toTime${i}`])
          {
            let toTime = this.data.workingTimeSchema[`toTime${i}`] ;
            let fromTime = this.data.workingTimeSchema[`fromTime${i}`];
            let fromTimeInput = fromTime instanceof Date && !isNaN(fromTime.getTime()) ? 
              DateUtil.converDateToStringNoAddOffset(fromTime) : fromTime;
            let toTimeInput = toTime instanceof Date && !isNaN(toTime.getTime()) ? 
              DateUtil.converDateToStringNoAddOffset(toTime) : toTime;
            this.arrayHoursWorking.push(
              { 
                fromTime: DateUtil.returnHoursMinutesFromString(fromTimeInput), 
                toTime: DateUtil.returnHoursMinutesFromString(toTimeInput), 
                idEdit: i 
              }
            );
          }
        }
      }
    }
    if (this.data.isWorking) {
      this.isWorking = this.data.isWorking;
    }
    this.restartDefaultValues();
  }

  ok() {
    if (this.currentDateType === 'exact') {
      this.startDate = null;
      this.finishDate = null;
      this.onDate.setHours(0, 0, 0, 0);
    } else if (this.currentDateType === 'range') {
      this.onDate = null;
      this.startDate.setHours(0, 0, 0, 0);
      this.finishDate.setHours(0, 0, 0, 0);
    }

    if ((this.currentDateType === 'exact' && this.isValidDate(this.onDate)) || 
      (this.currentDateType === 'range' && this.isValidDate(this.startDate) && this.isValidDate(this.finishDate))) {
      let workingTimeSchema = {
        currentDateType: this.currentDateType,
        onDate: this.onDate,
        startDate: this.startDate,
        finishDate: this.finishDate,
      }
      for (let i = 1; i <= 5; i++) {
        if (i <= this.arrayHoursWorking.length) {
          workingTimeSchema[`fromTime${i}`] = this.currentDateType === 'range' ? 
            this.setTimeFromStringToDate(this.arrayHoursWorking[i-1].fromTime, this.startDate) : this.setTimeFromStringToDate(this.arrayHoursWorking[i-1].fromTime, this.onDate);
          workingTimeSchema[`toTime${i}`] = 
            this.currentDateType === 'range' ? this.setTimeFromStringToDate(this.arrayHoursWorking[i-1].toTime, this.finishDate) : this.setTimeFromStringToDate(this.arrayHoursWorking[i-1].toTime, this.onDate);
        } else {
          workingTimeSchema[`fromTime${i}`] = null;
          workingTimeSchema[`toTime${i}`] = null;
        }
      }
      this.modalComponentRef.close(workingTimeSchema);
    } else {
      this.showToast(this._i18nService.instant('WORKING_TIME_SCHEMA.INVALID_DATE'), 'error');
    }
  }

  addHours() {
    if (this.timeToMinutes(this.toTimeStr) > this.timeToMinutes(this.fromTimeStr)) {
      if (this.isTimeRangeAvailable()) {
        if (this.idEdit === 0) {
          let idEdit = this.arrayHoursWorking.reduce((max, item) => item.idEdit > max ? item.idEdit : max, 0) + 1;
          this.arrayHoursWorking.push({ fromTime: this.fromTimeStr, toTime: this.toTimeStr, idEdit });
        } else {
          this.arrayHoursWorking = this.arrayHoursWorking.map(item => {
            if (item.idEdit === this.idEdit) {
              item.fromTime = this.fromTimeStr;
              item.toTime = this.toTimeStr;
            }
            return item;
          });
        }
        
        this.idEdit = 0;
        this.sortArrayHoursWorking();
        this.restartDefaultValues();
      } else
        this.showToast(this._i18nService.instant('WORKING_TIME_SCHEMA.HOUR_TAKEN'), 'error');
    } else
      this.showToast(this._i18nService.instant('WORKING_TIME_SCHEMA.HOUR_INVALID'), 'error');
    
  }

  editHours(workingHours) {
    this.fromTime = this.setTimeFromStringToDate(workingHours.fromTime);
    this.toTime = this.setTimeFromStringToDate(workingHours.toTime);
    this.idEdit = workingHours.idEdit;
  }

  deleteHours(workingHours) {
    this.arrayHoursWorking = this.arrayHoursWorking.filter(item  => item.idEdit !== workingHours.idEdit);
    this.resetIdEdit();
  }

  isTimeRangeAvailable(): boolean {
    const fromTime = this.timeToMinutes(this.fromTimeStr);
    const toTime = this.timeToMinutes(this.toTimeStr);

    for (const workingTime of this.arrayHoursWorking) {
      if (this.idEdit === 0 || (this.idEdit !== 0 && this.idEdit !== workingTime.idEdit)) {
        const workingFromTime = this.timeToMinutes(workingTime.fromTime);
        const workingToTime = this.timeToMinutes(workingTime.toTime);

        if ((fromTime >= workingFromTime && fromTime <= workingToTime) ||
          (toTime >= workingFromTime && toTime <= workingToTime) ||
          (fromTime <= workingFromTime && toTime >= workingToTime)) {
          return false;
        }
      }
    }

    return true;
  }

  sortArrayHoursWorking(): void {
    this.arrayHoursWorking.sort((a, b) => {
      const fromTimeA = this.timeToMinutes(a.fromTime);
      const fromTimeB = this.timeToMinutes(b.fromTime);
      return fromTimeA - fromTimeB;
    });
  }

  timeToMinutes(timeStr: string): number {
    let timePart = timeStr;
    if (timeStr.includes('T')) 
      timePart = timeStr.split('T')[1]; 
    
    const [hours, minutes] = timePart.split(':').map(Number); // Dividir en horas y minutos
    return hours * 60 + minutes;
  }

  changeDatePicker(newDate, date) {
    if (date === 0) 
      this.fromTimeStr = DateUtil.returnHoursMinutes(newDate);
    else
      this.toTimeStr = DateUtil.returnHoursMinutes(newDate);
  }

  setTimeFromStringToDate(timeStr: string, dateinput?: Date): Date {
    const [hours, minutes] = timeStr.split(':').map(Number);
    const date = dateinput ? new Date(dateinput) : new Date();
    date.setHours(hours, minutes, 0, 0);
    return date;
  }

  resetIdEdit() {
    for (let i = 0; i < this.arrayHoursWorking.length; i++) {
      this.arrayHoursWorking[i].idEdit = i + 1;
    }
  }

  areDatesSameDay(date1: Date, date2: Date): boolean {
    return date1.getFullYear() === date2.getFullYear() &&
          date1.getMonth() === date2.getMonth() &&
          date1.getDate() === date2.getDate();
  }

  restartDefaultValues() {
    this.fromTimeStr = '00:00';
    this.toTimeStr = '23:59';
    this.fromTime = this.setTimeFromStringToDate(this.fromTimeStr);
    this.toTime = this.setTimeFromStringToDate(this.toTimeStr);
  }

  btnEnable() {
    return this.currentDateType && (!this.isWorking || (this.isWorking && this.arrayHoursWorking.length > 0));
  }

  setIcon () {
    return this.idEdit === 0 ? 'icon-plus' : 'icon-edit';
  }

  isValidDate(date: any): boolean {
    const parsedDate = new Date(date);
    return !isNaN(parsedDate.getTime());
  }

  close() {
    this.modalComponentRef.close();
  }

  showToast(messageInput: string, type: BzgToastType) {
    this._toastService.open(
      messageInput,
      {
        type,
        duration: 5000,
        verticalPosition: 'bottom',
        horizontalPosition: 'right'
      });
  }
}
